import React from 'react';
import { motion } from 'framer-motion';
interface ScrollRevealProps {
  children: React.ReactNode;
  delay?: number;
  direction?: 'up' | 'down' | 'left' | 'right' | 'none';
  className?: string;
  width?: 'fit-content' | '100%';
  blur?: boolean;
  scale?: boolean;
  clipReveal?: 'left' | 'right' | 'top' | 'bottom' | 'none';
  distance?: number;
  duration?: number;
}
export const ScrollReveal = ({
  children,
  delay = 0,
  direction = 'up',
  className = '',
  width = '100%',
  blur = true,
  scale = false,
  clipReveal = 'none',
  distance = 60,
  duration = 1
}: ScrollRevealProps) => {
  const getInitialY = () => {
    if (direction === 'up') return distance;
    if (direction === 'down') return -distance;
    return 0;
  };
  const getInitialX = () => {
    if (direction === 'left') return distance;
    if (direction === 'right') return -distance;
    return 0;
  };
  const getInitialClipPath = () => {
    if (clipReveal === 'left') return 'inset(0 100% 0 0)';
    if (clipReveal === 'right') return 'inset(0 0 0 100%)';
    if (clipReveal === 'top') return 'inset(100% 0 0 0)';
    if (clipReveal === 'bottom') return 'inset(0 0 100% 0)';
    return 'inset(0 0 0 0)';
  };
  const isClipReveal = clipReveal !== 'none';
  return <div style={{
    width
  }} className={className} data-id="element-145">
      <motion.div initial={{
      opacity: isClipReveal ? 1 : 0,
      y: isClipReveal ? 0 : getInitialY(),
      x: isClipReveal ? 0 : getInitialX(),
      filter: blur && !isClipReveal ? 'blur(8px)' : 'blur(0px)',
      scale: scale && !isClipReveal ? 0.95 : 1,
      clipPath: getInitialClipPath()
    }} whileInView={{
      opacity: 1,
      y: 0,
      x: 0,
      filter: 'blur(0px)',
      scale: 1,
      clipPath: 'inset(0 0 0 0)'
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration,
      delay,
      ease: [0.16, 1, 0.3, 1]
    }} className={isClipReveal ? 'w-full h-full' : ''} data-id="element-146">
        {children}
      </motion.div>
    </div>;
};